<template>
  <div class="password-container" :style="'min-height:'+min_height+'px;'">
    <div class="password-content">
      <div class="password-null" v-if="password==''">
        <p class="title SourceHanSansCN">请设置新密码</p>
        <el-form :model="formData" status-icon :rules="rules" ref="ruleForm" class="password-form">
          <el-form-item prop="password">
            <el-input type="password" placeholder="密码由8-16为字母、数字、下划线等至少2种组成" v-model="formData.password" show-password style="width: 40%" autocomplete="off"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="password-not-empty" v-else>
        <p class="title SourceHanSansCN">请设置新密码</p>
        <el-form :model="formData2" status-icon :rules="rule" ref="ruleForm2" class="password-form" label-position="top" hide-required-asterisk>
          <el-form-item prop="oldPassword" label="旧密码">
            <el-input type="password" placeholder="请输入" v-model="formData2.oldPassword" show-password style="width: 40%" autocomplete="off"/>
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input type="password" placeholder="密码由8-16为字母、数字、下划线等至少2种组成" v-model="formData2.newPassword" show-password style="width: 40%" autocomplete="off"/>
          </el-form-item>
          <el-form-item>
            <el-button type="danger" @click="submitForm('ruleForm2')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {verifyOldPassword,updatePws} from '@/api/systemSetting'
export default {
  name: "loginPassword",
  data(){
    /*密码校验*/
    let checkPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      let regex = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)(?![_/*+~!@#、|":$%^&*(){}_+=;}{,./?]+$)[0-9A-Za-z_/*+~!@#、|":$%^&*(){}_+=;}{,./?]{8,16}$');
      if (regex.test(value)) {
        callback();
      } else {
        callback(new Error('密码由8-16位数字/字母/标点符号至少2种组成'));
      }
    }
    return{
      password:'123456wsq',
      formData:{
        password:'',
      },
      /*表单校验*/
      rules: {
        password: [
          {validator: checkPassword, trigger: 'blur'}
        ],
      },
      rule:{
        oldPassword: { required: true, trigger: 'blur', message: '请输入密码!' },
        newPassword: {validator: checkPassword, trigger: 'blur'}
      },
      formData2:{
        oldPassword:'',
        newPassword:'',
      },
      min_height: document.documentElement.clientHeight - 396,
    }
  },
  methods:{
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let uid=JSON.parse(sessionStorage.getItem('loginData')).cid;
          let mobile=JSON.parse(sessionStorage.getItem('loginData')).mobile;
          verifyOldPassword({userId: uid, mobile: mobile, oldPwd: this.formData2.oldPassword, uid: uid, request:'form'}).then(res=>{
            if (res.code==200){
              updatePws({id: uid, mobile: mobile, pwd: this.formData2.newPassword, smscode: "", uid: uid, uuid: "",}).then(res=>{
                if (res.code==200){
                  this.$message.success('修改成功！');
                  this.formData2={oldPassword:'', newPassword:''}
                }else{
                  this.$message.error('修改失败！');
                }
              })
            }else{
              this.$message.error('密码错误！');
            }
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style scoped>
.password-container >>> .password-content .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 10px 30px;
}

.password-container >>> .password-content .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
</style>
<style scoped lang="scss">
.password-container {
  background: #ffffff;
  padding: 20px;

  .password-content {
    .password-null{
      .title {
        margin-block-start: 0px;
        font-size: 16px;
        color: #333333;
      }
    }
    .password-not-empty{
      .title {
        margin-block-start: 0px;
        font-size: 16px;
        color: #333333;
      }
    }
  }
}
</style>